import { useCallback, useEffect, useState } from 'react'
 
const PAGE_SIZE = 80
const SCROLL_THRESHOLD_PX = 120
 
export function useInfiniteScroll(total: number) {
  const [visible, setVisible] = useState(PAGE_SIZE)
 
  // Reset when the underlying list changes (e.g. dimension switch).
  useEffect(() => {
    setVisible((v) => Math.min(v, Math.max(PAGE_SIZE, total)))
  }, [total])
 
  const onScroll = useCallback((e: React.UIEvent<HTMLDivElement>) => {
    const el = e.currentTarget
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - SCROLL_THRESHOLD_PX
    if (nearBottom) {
      setVisible((v) => Math.min(total, v + PAGE_SIZE))
    }
  }, [total])
 
  return { visible, onScroll, hasMore: visible < total }
}
 